module.exports = ".card-header-notification {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n\n.date-notification {\n  color: gray;\n  font-size: 0.8em; }\n\n/deep/ .mat-card-header-text {\n  margin-left: 0px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/notifications/notifications.component.scss
// module id = ./src/app/admin/pages/notifications/notifications.component.scss
// module chunks = main